import { createContext } from 'react';
import { ButtonColor } from './ButtonColor';
import { ButtonVariant } from './ButtonVariant';

export interface ButtonContextValue {
  variant?: ButtonVariant;
  color?: ButtonColor;
}

export const ButtonContext = createContext<ButtonContextValue>({});
